import { History } from "history";

import { PaginateQuery, UpdateCourseDurationRequest } from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";
import { CourseDurationDto } from "../../interfaces/course";

//#region Get Course Durations

export const GET_COURSE_DURATIONS = "GET_COURSE_DURATIONS";
export const GET_COURSE_DURATIONS_SUCCESS: any = "GET_COURSE_DURATIONS_SUCCESS";
export const GET_COURSE_DURATIONS_ERROR: any = "GET_COURSE_DURATIONS_ERROR";

export interface GetCourseDurationsAction {
  type: typeof GET_COURSE_DURATIONS;
  payload: {
    gradeId: string;
    courseId: string;
    request: PaginateQuery;
    history: History;
  };
}

export interface GetCourseDurationsSuccessAction {
  type: typeof GET_COURSE_DURATIONS_SUCCESS;
  payload: Paginated<CourseDurationDto>;
}

export interface GetCourseDurationsErrorAction {
  type: typeof GET_COURSE_DURATIONS_ERROR;
  payload: any;
}
//#endregion

//#region Get Course Duration

export const GET_COURSE_DURATION = "GET_COURSE_DURATION";
export const GET_COURSE_DURATION_SUCCESS: any = "GET_COURSE_DURATION_SUCCESS";
export const GET_COURSE_DURATION_ERROR: any = "GET_COURSE_DURATION_ERROR";

export interface GetCourseDurationAction {
  type: typeof GET_COURSE_DURATION;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetCourseDurationSuccessAction {
  type: typeof GET_COURSE_DURATION_SUCCESS;
  payload: CourseDurationDto;
}

export interface GetCourseDurationErrorAction {
  type: typeof GET_COURSE_DURATION_ERROR;
  payload: any;
}
//#endregion

//#region Update Course Duration

export const UPDATE_COURSE_DURATION = "UPDATE_COURSE_DURATION";
export const UPDATE_COURSE_DURATION_SUCCESS: any =
  "UPDATE_COURSE_DURATION_SUCCESS";
export const UPDATE_COURSE_DURATION_ERROR: any = "UPDATE_COURSE_DURATION_ERROR";

export interface UpdateCourseDurationAction {
  type: typeof UPDATE_COURSE_DURATION;
  payload: {
    request: UpdateCourseDurationRequest[];
    history: History;
  };
}

export interface UpdateCourseDurationSuccessAction {
  type: typeof UPDATE_COURSE_DURATION_SUCCESS;
  payload: null;
}

export interface UpdateCourseDurationErrorAction {
  type: typeof UPDATE_COURSE_DURATION_ERROR;
  payload: any;
}
//#endregion

//#region Delete CourseDuration

export const DELETE_COURSE_DURATION_CONSENT: any =
  "DELETE_COURSE_DURATION_CONSENT";
export const DELETE_COURSE_DURATION = "DELETE_COURSE_DURATION";
export const DELETE_COURSE_DURATION_SUCCESS: any =
  "DELETE_COURSE_DURATION_SUCCESS";
export const DELETE_COURSE_DURATION_ERROR: any = "DELETE_COURSE_DURATION_ERROR";

export interface DeleteCourseDurationConsentAction {
  type: typeof DELETE_COURSE_DURATION_CONSENT;
  payload: string;
}

export interface DeleteCourseDurationAction {
  type: typeof DELETE_COURSE_DURATION;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteCourseDurationSuccessAction {
  type: typeof DELETE_COURSE_DURATION_SUCCESS;
  payload: null;
}

export interface DeleteCourseDurationErrorAction {
  type: typeof DELETE_COURSE_DURATION_ERROR;
  payload: any;
}
//#endregion

//#region Rollover

export const ROLLOVER = "ROLLOVER";
export const ROLLOVER_SUCCESS: any = "ROLLOVER_SUCCESS";
export const ROLLOVER_ERROR: any = "ROLLOVER_ERROR";

export interface RolloverAction {
  type: typeof ROLLOVER;
  payload: {};
}

export interface RolloverSuccessAction {
  type: typeof ROLLOVER_SUCCESS;
  payload: null;
}

export interface RolloverErrorAction {
  type: typeof ROLLOVER_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetCourseDurationsAction
  | GetCourseDurationsSuccessAction
  | GetCourseDurationsErrorAction
  | GetCourseDurationAction
  | GetCourseDurationSuccessAction
  | GetCourseDurationErrorAction
  | UpdateCourseDurationAction
  | UpdateCourseDurationSuccessAction
  | UpdateCourseDurationErrorAction
  | DeleteCourseDurationConsentAction
  | DeleteCourseDurationAction
  | DeleteCourseDurationSuccessAction
  | DeleteCourseDurationErrorAction
  | RolloverAction
  | RolloverSuccessAction
  | RolloverErrorAction;
